:host{min-width:40px;max-height:40px}:host ::ng-deep svg{height:40px;vertical-align:middle;fill:#333}
/*# sourceMappingURL=category-icon.component-NWLL6OJY.css.map */
